import React from "react";
import { numberWithSpaces } from "../../utils";
import usePaging from "./usePaging";
import { pagingType } from "../../../common/types/search/search";

export function Showing({ paging }: { paging: pagingType }) {
	const { currentPage, pageSize, results, pages } = usePaging(paging);

	if (pages <= 1) {
		return null;
	}

	const resultsFormatted = numberWithSpaces(results);

	let resultsShowingFrom: number;
	let resultsShowingTo: number;

	if (currentPage === 0) {
		resultsShowingFrom = 1;
		resultsShowingTo = results < pageSize ? results : pageSize;
	} else if (currentPage + 1 === pages) {
		resultsShowingFrom = pageSize * currentPage + 1;
		resultsShowingTo = results;
	} else {
		resultsShowingFrom = pageSize * currentPage + 1;
		resultsShowingTo = pageSize * (currentPage + 1);
	}

	return (
		<p className="results-showing">
			Showing {numberWithSpaces(resultsShowingFrom)}-
			{numberWithSpaces(resultsShowingTo)} of {resultsFormatted}
		</p>
	);
}
